/// <amd-module name="Build/PipelinesLanguage/Services/ValidationService" />
import { TextDocument } from "AzurePipelinesLanguageService";
import { AzurePipelinesLanguageService } from "../Utils/LanguageProviders";
import { createDocument, ProtocolToMonacoConverter } from "../Utils/MonacoConverters";

const validationThrottleTimeoutMs = 200;

export class ValidationService {
    private _pendingValidationRequests: { [key: string]: number | undefined };

    constructor(private model: monaco.editor.ITextModel, private languageService: AzurePipelinesLanguageService) {
        this._pendingValidationRequests = {};
    }

    public validate = (): void => {
        const document = createDocument(this.model);
        this._cleanPendingValidation(document);
        this._pendingValidationRequests[document.uri] = setTimeout(() => {
            this._pendingValidationRequests[document.uri] = undefined;
            this._doValidate(document);
        }, validationThrottleTimeoutMs);
    };

    private _cleanPendingValidation(document: TextDocument): void {
        const request = this._pendingValidationRequests[document.uri];
        if (request !== undefined) {
            clearTimeout(request);
            this._pendingValidationRequests[document.uri] = undefined;
        }
    }

    private _doValidate(document: TextDocument): void {
        if (document.getText().length === 0) {
            // clean diagnostics
            this._setModelMarkers([]);
            return;
        }

        const yamlDocument = this.languageService.parse(document.getText());
        this.languageService.doValidation(document, yamlDocument).then(diagnostics => {
            const markers = ProtocolToMonacoConverter.asDiagnostics(diagnostics) || [];
            this._setModelMarkers(markers);
        });
    }

    private _setModelMarkers(markers: monaco.editor.IMarkerData[]): void {
        if (monaco) {
            monaco.editor.setModelMarkers(this.model, "default", markers);
        }
    }
}
